module.exports = __webpack_public_path__ + "static/media/FuturaBT-BoldCondensed.e51eca6e.ttf";